(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["daymerit-video-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('daymerit-media-slider')) {
    class DaymeritMediaSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-slider-track]');
        this.prev = this.querySelector('[data-slider-prev]');
        this.next = this.querySelector('[data-slider-next]');

        if (!this.track || !this.prev || !this.next) return;

        this.onPrev = () => this.scrollByCard(-1);
        this.onNext = () => this.scrollByCard(1);
        this.onScroll = () => this.syncButtons();

        this.prev.addEventListener('click', this.onPrev);
        this.next.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        this.resizeObserver = new ResizeObserver(() => this.syncButtons());
        this.resizeObserver.observe(this.track);

        this.observeVideos();
        this.syncButtons();
      }

      disconnectedCallback() {
        if (!this.track) return;

        this.prev?.removeEventListener('click', this.onPrev);
        this.next?.removeEventListener('click', this.onNext);
        this.track.removeEventListener('scroll', this.onScroll);
        this.resizeObserver?.disconnect();
        this.videoObserver?.disconnect();
      }

      getStep() {
        const firstCard = this.track.querySelector('.dm-video-slider__card');
        if (!firstCard) return this.track.clientWidth * 0.8;

        const styles = getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap || 0);
        return firstCard.getBoundingClientRect().width + gap;
      }

      scrollByCard(direction) {
        this.track.scrollBy({
          left: direction * this.getStep(),
          behavior: 'smooth'
        });
      }

      syncButtons() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const scrollable = max > 4;

        this.prev.hidden = !scrollable;
        this.next.hidden = !scrollable;

        if (!scrollable) return;

        this.prev.disabled = this.track.scrollLeft <= 4;
        this.next.disabled = this.track.scrollLeft >= max - 4;
      }

      observeVideos() {
        const videos = this.querySelectorAll('video[autoplay]');
        if (!videos.length || !('IntersectionObserver' in window)) return;

        this.videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        }, { threshold: [0, 0.35, 0.75] });

        videos.forEach((video) => this.videoObserver.observe(video));
      }
    }

    customElements.define('daymerit-media-slider', DaymeritMediaSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
